var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "causeCancelOrder",
      attrs: {
        id: "causeCancelOrder",
        title: _vm.modalTitle,
        centered: "",
        "cancel-title": "Отмена",
        "ok-title": "ОК"
      },
      on: {
        shown: function($event) {
          _vm.cancelCause = ""
        },
        ok: _vm.cancelOrder
      }
    },
    [
      _c(
        "b-form-group",
        {
          staticClass: "mb-0 flex-grow-0",
          attrs: {
            label: "Введите причину отмены заказа:",
            "label-for": "InputCause"
          }
        },
        [
          _c("b-form-input", {
            attrs: {
              id: "InputCause",
              required: "",
              trim: "",
              placeholder: "Комментарий"
            },
            model: {
              value: _vm.cancelCause,
              callback: function($$v) {
                _vm.cancelCause = $$v
              },
              expression: "cancelCause"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {},
            _vm._l(_vm.cancelCauses, function(cause) {
              return _c(
                "b-button",
                {
                  key: cause,
                  staticClass: "mt-2 mr-2",
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function($event) {
                      _vm.cancelCause = cause
                    }
                  }
                },
                [_vm._v(_vm._s(cause))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcbf378a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcbf378a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CancelOrder.vue
// module id = null
// module chunks = 